import React, { useState } from "react";
import { validateColor } from "./fieldValidation";
import * as palette from "@govlaunch/palette";

export default function ColorInput({ fieldName, label, placeholder, data, setData, required }) {
  const [touched, setTouched] = useState(false);

  return (
    <div
      css={{
        display: "grid",
        alignItems: "center",
        gridTemplateColumns: "1fr",
        gridRowGap: 4,
      }}
    >
      <span>{label}</span>

      <div
        css={{
          display: "flex",
          flexDirection: "row",
        }}
      >
        <input
          type="color"
          value={data[fieldName]}
          onChange={(e) => {
            setData({
              ...data,
              [fieldName]: e.target.value,
            });

            setTouched(true);
          }}
          css={{
            height: 30,
            width: 60,
            border: "solid 1px",
            borderColor: getBorderColor(data[fieldName], touched, required),
          }}
        />
        <input
          type="text"
          placeholder={placeholder}
          value={data[fieldName]}
          onChange={(e) => {
            setData({
              ...data,
              [fieldName]: e.target.value,
            });

            setTouched(true);
          }}
          css={{
            margin: 0,
            padding: 8,
            border: "solid 1px",
            borderColor: getBorderColor(data[fieldName], touched, required),
            borderRadius: 2,
            height: 30,
            width: 220,
            marginLeft: 4,
          }}
        />
      </div>
    </div>
  );
}

function getBorderColor(text, touched, required) {
  if (!required && !touched) {
    return palette.sealBlue;
  }

  if (required && touched && !validateColor(text)) {
    return palette.red;
  }

  return palette.sealBlue;
}
